import React, { useEffect, useState } from 'react';
import { useSearch } from '../../../utils/SearchProvider';

const StudentsList = () => {
    const [students, setStudents] = useState([]);
    const [filteredStudents, setFilteredStudents] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const { searchTerm } = useSearch();

    useEffect(() => {
        const fetchStudents = async () => {
            setIsLoading(true);
            try {
                await new Promise(resolve => setTimeout(resolve, 500));
                const mockStudents = [
                    {
                        id: 1,
                        name: "Rahul Singh",
                        email: "rahul321@gmail.com",
                        phone: "+91 111111111",
                        averageScore: "75.5%",
                        rank: "#1"
                    },
                    {
                        id: 2,
                        name: "Priya Sharma",
                        email: "priya.sharma@gmail.com",
                        phone: "+91 22222222",
                        averageScore: "82.3%",
                        rank: "#2"
                    },
                    {
                        id: 3,
                        name: "Rahul Verma",
                        email: "rahul.v45@gmail.com",
                        phone: "+91 333333",
                        averageScore: "68.9%",
                        rank: "#3"
                    },
                    {
                        id: 4,
                        name: "Ananya Patel",
                        email: "ananya.p@gmail.com",
                        phone: "+91 333333333",
                        averageScore: "91.2%",
                        rank: "#4"
                    },
                    {
                        id: 5,
                        name: "Vikram Malhotra",
                        email: "vikram2023@gmail.com",
                        phone: "+91 777777777",
                        averageScore: "73.7%",
                        rank: "#5"
                    }
                ];
                setStudents(mockStudents);
                setFilteredStudents(mockStudents);
            } catch (error) {
                console.error("Error fetching students:", error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchStudents();
    }, []);

    // Filter students when search term changes
    useEffect(() => {
        if (searchTerm.trim() === '') {
            setFilteredStudents(students);
        } else {
            const filtered = students.filter(student =>
                student.name.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setFilteredStudents(filtered);
        }
    }, [searchTerm, students]);

    return (
        <div className="w-full bg-white min-h-full mx-auto p-4">
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-xl font-bold">Student's List</h1>
                {searchTerm && (
                    <div className="text-blue-600">
                        {filteredStudents.length} result{filteredStudents.length !== 1 ? 's' : ''} for "{searchTerm}"
                    </div>
                )}
            </div>

            {isLoading ? (
                <div className="flex justify-center items-center h-40">
                    <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-solid border-blue-500"></div>
                </div>
            ) : filteredStudents.length === 0 ? (
                <div className="text-center py-10">
                    <p className="text-gray-500">No students found matching "{searchTerm}"</p>
                </div>
            ) : (
                <div className="overflow-x-auto">
                    <table className="w-full border-collapse">
                        <thead>
                            <tr className="bg-blue-50">
                                <th className="p-3 text-left border border-gray-200">Student Name</th>
                                <th className="p-3 text-left border border-gray-200">E-mail</th>
                                <th className="p-3 text-left border border-gray-200">Phone Number</th>
                                <th className="p-3 text-left border border-gray-200">Overall Average Score</th>
                                <th className="p-3 text-left border border-gray-200">Overall Rank</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredStudents.map((student) => (
                                <tr key={student.id} className="hover:bg-gray-50">
                                    <td className="p-3 border-b border-gray-200">{student.name}</td>
                                    <td className="p-3 border-b border-gray-200">{student.email}</td>
                                    <td className="p-3 border-b border-gray-200">{student.phone}</td>
                                    <td className="p-3 border-b border-gray-200">{student.averageScore}</td>
                                    <td className="p-3 border-b border-gray-200">{student.rank}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default StudentsList;